<template>
  <a-layout-sider
    :class="[theme, 'sider', isMobile ? null : 'shadow']" :collapsible="collapsible"
    v-model="collapsed" :trigger="null"
    width="256"
    style="background: #003667"
  >
    <div
      :class="['logo', theme]"
      style="background: #003667"
    >
      <router-link to="/">
        <img src="~@/assets/logo.png">
        <h1>{{ systemName }}</h1>
      </router-link>
    </div>
    <i-menu :theme="theme" :collapsed="collapsed" :menu="menuData" @select="onSelect" class="menu" />
  </a-layout-sider>
</template>

<script>
import IMenu from './menu'

export default {
  name: 'SiderMenu',
  components: { IMenu },
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  computed: {
    isMobile () {
      // return this.$store.state.setting.isMobile
      return false
    },
    systemName () {
      // return this.$store.state.setting.systemName
      return 'PMS'
    }
  },
  methods: {
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="less" scoped>
.shadow {
  box-shadow: 2px 0 6px rgba(0, 21, 41, .35);
}

.sider {
  z-index: 10;

  &.light {
    background-color: #fff;
  }

  &.dark {
    background-color: #001529;
  }

  .logo {
    height: 64px;
    position: relative;
    line-height: 64px;
    padding-left: 24px;
    -webkit-transition: all .3s;
    transition: all .3s;
    overflow: hidden;

    &.light {
      background-color: #fff;

      h1 {
        color: #1890ff;
      }
    }

    &.dark {
      background-color: #002140;

      h1 {
        color: #fff;
      }
    }

    h1 {
      color: #fff;
      font-size: 20px;
      margin: 0 0 0 12px;
      font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif;
      font-weight: 600;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      vertical-align: middle;
    }

    img {
      width: 32px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

</style>
